import { Box, Text, alpha, styled } from '@ltvco/refresh-lib/theme';
import { ChevronRight } from '@mui/icons-material';
import { Link as RouterLink } from 'react-router-dom';

import { META_BODY } from '../shared/constants';

export const BreadcrumbRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  alignItems: 'center',
  gap: theme.spacing(0.25),
  marginBottom: theme.spacing(2),
}));

export const BreadcrumbLink = styled(RouterLink)(({ theme }) => ({
  fontFamily: "'Lato', sans-serif",
  fontSize: 14,
  fontWeight: 400,
  lineHeight: '16.8px',
  letterSpacing: 0,
  color: theme.palette.primary.main,
  textDecoration: 'none',
  display: 'inline-flex',
  alignItems: 'center',
  '&:hover': {
    textDecoration: 'underline',
  },
}));

export const BreadcrumbCurrent = styled(Text)(() => ({
  fontFamily: "'Lato', sans-serif",
  fontSize: 14,
  fontWeight: 400,
  lineHeight: '16.8px',
  color: META_BODY,
  maxWidth: '100%',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
}));

export const BreadcrumbChevron = styled(ChevronRight)(({ theme }) => ({
  fontSize: 18,
  color: alpha(theme.palette.common.black, 0.38),
  flexShrink: 0,
}));
